import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

export const getConfiguracoesGetInstancia = async (): Promise<
  GetConfiguracoesInstacia | { message: string }
> => {
  try {
    const result = await apiService.get(
      `app/integracaowhatsapp/config/instancia`
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const getConfiguracoesDeletaInstancia = async (): Promise<
  { sucesso: string } | { message: string }
> => {
  try {
    const result = await apiService.delete(
      `app/integracaowhatsapp/config/instancia`
    )
    if (result.status === 200) {
      return { sucesso: 'Instância desconectada!' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
